import globals from "@/util/global-whitelist.mjs";
import useCallbackRef from "@/util/use-callback-ref.mjs";

// not stateful!!
export const useStickyAttribute = (
  rootEffector?: number | (HTMLElement | string)[],
  rootNode?: HTMLElement | string,
) =>
  useCallbackRef((node: HTMLElement) => {
    if (!(node instanceof HTMLElement)) return;
    const root =
      (typeof rootNode === "string"
        ? globals.document.querySelector(rootNode)
        : rootNode) || globals.document.body;

    const rootMarginPx =
      typeof rootEffector === "number"
        ? rootEffector
        : rootEffector?.reduce((prev, nodeEl) => {
            const node =
              typeof nodeEl === "string"
                ? globals.document.querySelector(nodeEl)
                : nodeEl;
            if (node instanceof HTMLElement) {
              prev = prev + node.offsetHeight;
            }
            return prev;
          }, 0) || 0;
    const rootMargin = `${rootMarginPx}px`;

    return watchSticky(node, {
      threshold: 1,
      root,
      rootMargin,
    });
  });

// Applies `stuck` attr to the supplied node when it is stuck
// css selector is [stuck].
// optionally runs callbacks on each intersection.
// if any callbacks return true, skip the stuck attribute
export const watchSticky = (
  node: HTMLElement,
  options?: ConstructorParameters<typeof IntersectionObserver>[1],
  ...callbacks: ((entry: IntersectionObserverEntry) => boolean)[]
) => {
  const obs = new IntersectionObserver(([entry]) => {
    const node = entry.target;
    if (!(node instanceof HTMLElement)) return;
    if (node.inert) return;
    let skip = false;
    callbacks?.forEach((callback) => {
      skip = skip || callback?.(entry);
    });
    if (skip) return;
    const stuck = entry.intersectionRatio < 1;
    entry.target[stuck ? "setAttribute" : "removeAttribute"]("stuck", "");
  }, options);
  obs.observe(node);

  return () => {
    obs.disconnect();
  };
};

export const useStickyParent = () => {};
